<template>
        <div class="ds-settings-exchange">
                <SettingsCard title="Доступность вакансии">
                        <div class="ds-settings-fields">
                                <label class="ds-settings-field ds-settings-field-wide">
                                        Минуты до доступности для внутренней сети (мин.)
                                        <base-input v-model="minutesUntilAvailableInnerWorkers" @input="onChanges" max-length="3"
                                                class="ds-settings-input"></base-input>
                                </label>
                                <label class="ds-settings-field ds-settings-field-wide">
                                        Минуты до доступности для аутсорс сети (мин.)
                                        <base-input v-model="minutesUntilAvailableOuterWorkers" @input="onChanges" max-length="3"
                                                class="ds-settings-input"></base-input>
                                </label>
                        </div>
                </SettingsCard>

                <SettingsCard title="Правила подбора">
                        <div class="ds-settings-rules">
                                <BooleanSwitch v-model="geoSetting">Учитывать регион</BooleanSwitch>
                                <BooleanSwitch v-model="specialitySetting">Учитывать специализацию</BooleanSwitch>
                                <BooleanSwitch v-model="prioritySetting">Учитывать приоритеты</BooleanSwitch>
                                <BooleanSwitch v-model="fastRule">Правило срочности</BooleanSwitch>
                                <BooleanSwitch v-model="autoApprove">Автоматическое подтверждение</BooleanSwitch>
                        </div>
                </SettingsCard>
                <div class="ds-settings-actions">
                        <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
                </div>
                <div v-if="saveError" class="ds-settings-error" role="alert">
                        Не удалось сохранить настройки. <button type="button" @click="save">Повторить</button>
                </div>
        </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useSettingsStore } from "@/stores/settingsStore";
import BooleanSwitch from "@/ui/BooleanSwitch.vue";
import SettingsCard from "@/ui/SettingsCard.vue";

const settingsStore = useSettingsStore();
const minutesUntilAvailableInnerWorkers = ref(
        settingsStore.settings?.MINUTES_UNTIL_AVAILABLE_INNER_WORKERS,
);
const minutesUntilAvailableOuterWorkers = ref(
        settingsStore.settings?.MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS,
);
const geoSetting = ref(settingsStore.settings?.DISTRIBUTION_SETTINGS_GEO);
const specialitySetting = ref(
        settingsStore.settings?.DISTRIBUTION_SETTINGS_SPECIALIZATION,
);
const prioritySetting = ref(
        settingsStore.settings?.DISTRIBUTION_SETTINGS_PRIORITY,
);
const fastRule = ref(settingsStore.settings?.FAST_RULE);
const autoApprove = ref(settingsStore.settings?.AUTO_APPROVE);
const isDisabled = ref(true);
const changes = ref<any[]>([]);
const saveError = ref(false);

const MINUTES_UNTIL_AVAILABLE_INNER_WORKERS =
        "MINUTES_UNTIL_AVAILABLE_INNER_WORKERS";
const MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS =
        "MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS";
const DISTRIBUTION_SETTINGS_GEO = "DISTRIBUTION_SETTINGS_GEO";
const DISTRIBUTION_SETTINGS_SPECIALIZATION =
        "DISTRIBUTION_SETTINGS_SPECIALIZATION";
const DISTRIBUTION_SETTINGS_PRIORITY = "DISTRIBUTION_SETTINGS_PRIORITY";
const FAST_RULE = "FAST_RULE";
const AUTO_APPROVE = "AUTO_APPROVE";

const isChanged = (field: any, option: string) => {
        if (field.value != settingsStore.settings[option]) {
                if (!changes.value.includes(option)) changes.value.push(option);
        } else {
                changes.value = changes.value.filter((item: string) => item !== option);
        }
};

const onChanges = () => {
        isChanged(
                minutesUntilAvailableInnerWorkers,
                MINUTES_UNTIL_AVAILABLE_INNER_WORKERS,
        );
        isChanged(
                minutesUntilAvailableOuterWorkers,
                MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS,
        );
        isChanged(geoSetting, DISTRIBUTION_SETTINGS_GEO);
        isChanged(specialitySetting, DISTRIBUTION_SETTINGS_SPECIALIZATION);
        isChanged(prioritySetting, DISTRIBUTION_SETTINGS_PRIORITY);
        isChanged(fastRule, FAST_RULE);
        isChanged(autoApprove, AUTO_APPROVE);
        isDisabled.value = !changes.value.length;
};

watch([geoSetting, specialitySetting, prioritySetting, fastRule, autoApprove], onChanges)

const getData = () => {
        const data: any = {};
        if (changes.value.includes(MINUTES_UNTIL_AVAILABLE_INNER_WORKERS))
                data.MINUTES_UNTIL_AVAILABLE_INNER_WORKERS =
                        minutesUntilAvailableInnerWorkers.value;
        if (changes.value.includes(MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS))
                data.MINUTES_UNTIL_AVAILABLE_OUTER_WORKERS =
                        minutesUntilAvailableOuterWorkers.value;
        if (changes.value.includes(DISTRIBUTION_SETTINGS_GEO))
                data.DISTRIBUTION_SETTINGS_GEO = geoSetting.value;
        if (changes.value.includes(DISTRIBUTION_SETTINGS_SPECIALIZATION))
                data.DISTRIBUTION_SETTINGS_SPECIALIZATION = specialitySetting.value;
        if (changes.value.includes(DISTRIBUTION_SETTINGS_PRIORITY))
                data.DISTRIBUTION_SETTINGS_PRIORITY = prioritySetting.value;
        if (changes.value.includes(FAST_RULE)) data.FAST_RULE = fastRule.value;
        if (changes.value.includes(AUTO_APPROVE))
                data.AUTO_APPROVE = autoApprove.value;
        return data
};

const save = async () => {
        const data = getData()
        const error = await settingsStore.changeSettings(data);
        if (error) {
                saveError.value = true;
                return;
        }

        saveError.value = false;
        isDisabled.value = true;
        changes.value = [];
};
</script>
